import { render, staticRenderFns } from "./modalInformacionLeechero.vue?vue&type=template&id=b87a0a72&scoped=true"
import script from "./modalInformacionLeechero.vue?vue&type=script&lang=js"
export * from "./modalInformacionLeechero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a0a72",
  null
  
)

export default component.exports